import TurndownService from 'turndown';
import { marked } from 'marked';

const turndown = new TurndownService({
  headingStyle: 'atx',
  bulletListMarker: '-',
});

export class EditorValue {
  private readonly _html: string;

  private constructor(html: string) {
    this._html = html;
  }

  static createFromString(
    str: string,
    format: 'html' | 'markdown',
  ): EditorValue {
    if (!str) return new EditorValue('');
    if (format === 'html') return new EditorValue(str);
    const html = marked.parse(str, { async: false });
    return new EditorValue(html);
  }

  toString(format: 'html' | 'markdown'): string {
    if (format === 'html') return this._html;
    return turndown.turndown(this._html || '');
  }

  static _fromHTML(html: string): EditorValue {
    return new EditorValue(html);
  }

  getHTML(): string {
    return this._html;
  }
}
